<template>
  <v-card rounded="lg" flat>
    <v-card-title class="subtitle-1 font-weight-bold">
      <v-row>
        <v-col> Frete </v-col>
        <v-col class="float-right">
          <modal-outros-valores-frete
            v-if="
              novopedido.cliente && novopedido.cliente.outrosfretes.length > 0
            "
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-form :disabled="novopedido.produtos.length > 0">
        <v-row dense>
          <v-col xl="4" lg="4" md="4" cols="12">
            <v-select
              :items="config.tiposfrete"
              label="Frete por conta:"
              v-model="novopedido.freteporconta"
              :disabled="getTipoPedidoSelec().bonificacao"
            ></v-select>
          </v-col>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-list-item :class="isMobile() ? 'pl-0' : ''">
              <v-list-item-content>
                <v-list-item-subtitle>Distância(KM)</v-list-item-subtitle>
                <v-list-item-title class="title">
                  {{
                    novopedido.cliente ? novopedido.cliente.distanciasede : 0
                  }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col xl="5" lg="5" md="5" cols="12">
            <v-list-item :class="isMobile() ? 'pl-0' : ''">
              <v-list-item-content>
                <v-list-item-subtitle>Valor Frete Padrão</v-list-item-subtitle>
                <v-list-item-title class="title">
                  <span v-if="novopedido.cliente.vlrdescfrete > 0">
                    <p class="mb-0">
                      <s>{{
                        formatarMoeda(novopedido.cliente.vlrfretepadrao)
                      }}</s>
                      <span class="ml-3"
                        ><v-chip class="success mb-1" dark x-small>Desc. frete:{{
                          formatarMoeda(novopedido.cliente.vlrdescfrete * -1)
                        }}</v-chip></span
                      >
                    </p>
                    <p class="">
                      {{
                        formatarMoeda(
                          novopedido.cliente.vlrfretepadrao -
                            novopedido.cliente.vlrdescfrete
                        )
                      }}
                    </p>
                  </span>
                  <span v-else>
                    {{
                      novopedido.cliente
                        ? formatarMoeda(novopedido.cliente.vlrfretepadrao)
                        : 0
                    }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { formatMoeda } from "@/global";
import ModalOutrosValoresFrete from "./ModalOutrosValoresFrete.vue";
export default {
  components: { ModalOutrosValoresFrete },
  computed: mapState("pedidos", ["novopedido", "config"]),
  methods: {
    ...mapGetters("pedidos", ["getTipoPedidoSelec"]),
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>